import {createApi} from '@reduxjs/toolkit/dist/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {
    EmployeeByIdSearchRequest,
    EmployeeCreateRequest,
    EmployeeDeleteRequest,
    EmployeeDTO,
    EmployeeSearchRequest,
    PageEmployeeInfo,
    UpdateEmployeeMutationRequest,
} from 'src/types/employee';
import {EmployeeStats} from 'src/types/stats';
import {getBaseURL} from 'src/utils/helper';

export const employeeApi = createApi({
    reducerPath: 'employee',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/employees'),
    }),
    tagTypes: ['employees', 'employee', 'User'],
    endpoints: (build) => {
        return {
            getEmployeeById: build.query<EmployeeDTO, EmployeeByIdSearchRequest>({
                query: ({params: {employeeId, ...rest}}) => ({
                    url: `/${employeeId}`,
                    method: 'get',
                    params: rest,
                }),
                providesTags: (result, _error, _arg) => [
                    'employee',
                    {type: 'User', id: result?.user?.id},
                ],
            }),
            // The same body the list is fetched with, so the block counts exactly the set the
            // list shows — the server drops the cells' own filters and forces the tenant.
            getEmployeeStats: build.query<EmployeeStats, EmployeeSearchRequest['data']>({
                query: (data) => ({url: '/stats/summary', method: 'post', data}),
                providesTags: ['employees'],
            }),
            searchEmployees: build.query<PageEmployeeInfo, EmployeeSearchRequest>({
                query: ({params, data}) => ({
                    url: '/search',
                    method: 'post',
                    params,
                    data,
                }),
                providesTags: ['employees'],
            }),
            deleteEmployeeById: build.mutation<void, EmployeeDeleteRequest>({
                query: ({params, employeeId}) => ({
                    url: `/${employeeId}`,
                    method: 'delete',
                    params,
                }),
                invalidatesTags: ['employees', {type: 'User', id: 'LIST'}],
            }),
            createNewEmployee: build.mutation<void, EmployeeCreateRequest>({
                query: (data) => ({
                    url: '',
                    method: 'post',
                    data,
                }),
                invalidatesTags: ['employees'],
            }),
            updateEmployeeById: build.mutation<EmployeeDTO, UpdateEmployeeMutationRequest>({
                query: ({employeeId, data}) => ({
                    url: `/${employeeId}`,
                    method: 'put',
                    data,
                }),
                invalidatesTags: ['employees', 'employee'],
            }),
        };
    },
});
